import { selectCurrentUser } from '@/modules/accounts'
import { commit, fail, ok, type Outcome } from '@/store/commit'
import type { AppThunk } from '@/store/create-store'

import { notificationsRead } from './store/notifications-slice'

const now = () => new Date().toISOString()

/** Marks one of the signed-in user's notifications read. The record is kept. */
export function markNotificationRead(id: string): AppThunk<Promise<Outcome>> {
  return commit(({ dispatch, getState }) => {
    const user = selectCurrentUser(getState())
    if (!user) return fail('Your session has ended. Sign in again.')
    const notification = getState().notifications.entities[id]
    if (!notification || notification.recipientUserId !== user.id) return fail('That notification isn’t yours.')
    dispatch(notificationsRead({ ids: [id], at: now() }))
    return ok(undefined)
  })
}

export function markAllNotificationsRead(): AppThunk<Promise<Outcome>> {
  return commit(({ dispatch, getState }) => {
    const user = selectCurrentUser(getState())
    if (!user) return fail('Your session has ended. Sign in again.')
    const ids = Object.values(getState().notifications.entities)
      .filter((item) => item?.recipientUserId === user.id && !item.readAt)
      .map((item) => item!.id)
    if (ids.length) dispatch(notificationsRead({ ids, at: now() }))
    return ok(undefined)
  })
}
